const exclamationMarkIcon = `<svg width="26" height="23" viewBox="0 0 26 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.9998 0.333313L0.166504 22.5H25.8332M12.9998 4.99998L21.7848 20.1666H4.21484M11.8332 9.66665V14.3333H14.1665V9.66665M11.8332 16.6666V19H14.1665V16.6666" fill="#1A1A1A"/>
</svg>`;

/**
 * renders HTML content of the error message.
 * Common for both React and plain JS version.
 */
export const renderErrorMessageContent = (title: string, content: string) => `
    <div style="position: relative;display: flex;flex-direction: row;align-items: flex-start;">
        <div style="margin-right: 13px;">${exclamationMarkIcon}</div>
            <div style="display: flex; flex-direction: column; margin-right: 5px;">
                <div style="margin-bottom: 10px; font-size: 1.15em; font-weight:bold;">${title}</div>
                <div style="font-size: 0.9em;">${content}</div>
            </div>
    </div>
`;
